// extracted by mini-css-extract-plugin
module.exports = {"container":"idt-aspectratio_container__1k-wi","element":"idt-aspectratio_element__2ykez"};